// extracted by css-extract-rspack-plugin
export default {"cls1":"Thumbnail-cls1_ZoM","cls2":"Thumbnail-cls2_U_- Thumbnail-cls1_ZoM"};